import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import PageHeader1 from "../../components/common/PageHeader1";
import { submitMeditationCatApi, getMeditationCatByIdApi } from "../../services/MeditationCat";

function AddMeditationCat() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [options, setOptions] = useState([""]); // For dynamic options
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  // Fetch question details if editing
  useEffect(() => {
    if (id) {
      (async () => {
        const res = await getMeditationCatByIdApi(id);
        if (res?.data) {
          const r = res.data;
          setValue("name", r.name);
        }
      })();
    }
  }, [id, setValue]);

  // Handle dynamic option field changes
 


  // Submit logic
  const onSubmit = async (data) => {
    const payload = {
      ...data,
    };

    if (id) payload._id = id;

    const res = await submitMeditationCatApi(payload);
    if (res) {
      // toast.success(id ? "Question updated successfully!" : "Question added successfully!");
      if (!id) {
        reset();
        setOptions([""]);
      } else {
        navigate("/meditation-categories");
      }
    }
  };

  return (
    <div className="container">
      <PageHeader1
        pagetitle={id ? "Edit Meditation Category" : "Add Meditation Category"}
        navigation="Meditation Categories"
        navlink="/meditation-categories"
        current={id ? "Edit" : "Add"}
      />

      <div className="col-lg-10 mx-auto">
        <div className="card p-4 shadow-sm">
          <form onSubmit={handleSubmit(onSubmit)} className="row g-3">
            <div className="col-12 text-center">
              <h2>{id ? "Edit Category" : "Add New Category"}</h2>
            </div>

            {/* Question Field */}
            <div className="col-md-6">
              <label className="form-label">Name</label>
              <input
                className="form-control"
                {...register("name", { required: "Name is required" })}
              />
              {errors.name && <p className="text-danger">{errors.name.message}</p>}
            </div>

            
           

            {/* Submit Buttons */}
            <div className="col-12 text-center mt-4">
              <Button type="submit" className="btn btn-primary px-5 me-3">
                {id ? "Update" : "Save"}
              </Button>
              <Button
                variant="secondary"
                className="px-5"
                onClick={() => navigate("/meditation-categories")}
              >
                Back
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddMeditationCat;
